import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { Item } from '../../../core/components/listbox/listbox.component';

@Component({
  selector: 'tt-batch-deliveries',
  templateUrl: './batch-deliveries.component.html',
  styleUrls: ['./batch-deliveries.component.css']
})
export class BatchDeliveriesComponent implements OnInit {
    argType;

    argValue;

    public setting?: Setting;

    public itemsListRelatedTo: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.argType = this.stateService.getStateParams()['argtype'];
        this.argValue = this.stateService.getStateParams()['argvalue'];
    }

    private async loadSetting() {
        if (!!this.argType && !!this.argValue) {
            this.setting = (await this.datatask.Post(897, {
                argtype: this.argType,
                argvalue: this.argValue
            }))[0];
        }
    }

    private async loadRelatedTo() {
        if (!!this.argType && !!this.argValue) {
            this.itemsListRelatedTo = await this.datatask.Post(701, {
                argtype: this.argType,
                argvalue: this.argValue
            });
        }
    }

    private async init() {
        this.loadSetting();
        this.loadRelatedTo();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    page_heading: string;
}
